module.exports = __webpack_public_path__ + "media/images/redrock/hero-image-winter-small-c995ae29765f6fc96b62de0fa0783f6a.jpg";